export default __webpack_public_path__ + "static/media/bannerThreex2.47bfbc14.png";